import React from 'react';
import uniqueId from 'lodash/uniqueId';
import PdpSubmissionItem from './pdpSubmissionItem';
import { withNurseryContext } from '../../contexts/NurseryContext';
var PdpSubmission = function (_a) {
    var title = _a.title, data = _a.data, nurserySlug = _a.nurserySlug;
    var launchCarousel = function (e) {
        e.preventDefault();
    };
    var filteredItems = data.filter(function (item) {
        if (nurserySlug
            && !item.is_photo
            && item.contributor_info.is_nursery) {
            return item.contributor_info.slug === nurserySlug;
        }
        return true;
    });
    var items = filteredItems.map(function (item, index) { return (React.createElement(PdpSubmissionItem, { key: uniqueId(item.contributor_info.name), data: item, title: title, launchCarousel: launchCarousel, activeIndex: index })); });
    return (items && items.length > 0) && (React.createElement("div", { className: "submissions_wrapper" },
        React.createElement("div", { className: "submissions" },
            React.createElement("h2", null, "Garden photo gallery of ".concat(title)),
            React.createElement("div", { className: "submissions_grid" }, items))));
};
export default withNurseryContext(PdpSubmission);
